import React, { FC } from 'react'

import { EditPriceField } from './EditPriceField'

import { getFloatPrice } from '../../../helpers/price'

const Price = ({
  price,
  isQualify,
  qualifyFee,
  qualifyFeeName,
  currency,
}: {
  price: number
  isQualify?: boolean | null
  qualifyFee?: string | null
  qualifyFeeName?: string | null
  currency: string
}) => {
  return (
    <>
      {getFloatPrice(`${currency}${price}`)}
      {isQualify && ` • ${getFloatPrice(`${currency}${qualifyFee}`)} ${qualifyFeeName || 'qual'}`}
    </>
  )
}

interface PriceItemProps {
  isRefunded?: boolean
  amountRefunded: number
  price: number
  originalPrice: number
  isQualify?: boolean | null
  qualifyFee?: string | null
  qualifyFeeName?: string | null
  showAdjustField?: boolean
  onCancelAdjust?: () => void
  onSaveAdjust?: (value: number) => Promise<void>
  showRefundField?: boolean
  onCancelRefund?: () => void
  onSaveRefund?: (value: number) => Promise<void>
  onSaveAssign?: (teamMember: number) => Promise<void>
  currency: string
}

export const PriceItem: FC<PriceItemProps> = ({
  isRefunded,
  amountRefunded,
  price,
  originalPrice,
  qualifyFee,
  isQualify,
  qualifyFeeName,
  showAdjustField,
  onCancelAdjust,
  onSaveAdjust,
  showRefundField,
  onCancelRefund,
  onSaveRefund,
  currency,
}) => {
  return (
    <div className="inline-flex flex-wrap items-center gap-2">
      {isRefunded ? (
        <div className="flex items-center gap-1">
          <span className="line-through text-gray-400">
            <Price
              price={price - originalPrice}
              isQualify={isQualify}
              qualifyFee={qualifyFee}
              qualifyFeeName={qualifyFeeName}
              currency={currency}
            />
          </span>
          <span className="font-bold">
            {getFloatPrice(
              `${currency}${(isQualify ? price + Number(qualifyFee) : price) + originalPrice - amountRefunded}`
            )}
          </span>
        </div>
      ) : (
        <span className="font-medium">
          {originalPrice > 0 ? (
            <div className="flex items-center gap-1">
              <span className="line-through text-gray-400">
                <Price
                  price={originalPrice}
                  isQualify={isQualify}
                  qualifyFee={qualifyFee}
                  qualifyFeeName={qualifyFeeName}
                  currency={currency}
                />
              </span>
              <span>Adjusted to ${price}</span>
            </div>
          ) : (
            <span className="font-medium">
              <Price
                price={price}
                isQualify={isQualify}
                qualifyFee={qualifyFee}
                qualifyFeeName={qualifyFeeName}
                currency={currency}
              />
            </span>
          )}
        </span>
      )}
      {showAdjustField && (
        <EditPriceField label="Adjust to" onCancel={onCancelAdjust} onSave={onSaveAdjust} />
      )}
      {showRefundField && (
        <EditPriceField label="Refund to" onCancel={onCancelRefund} onSave={onSaveRefund} />
      )}
    </div>
  )
}
